import { format as formatDate, parseISO } from 'date-fns'
import type { ReactNode } from 'react'

interface DateTimeProps {
  value: string | Date | null | undefined
  // must be an HTML element or React component
  element?: string | React.ComponentType<any>
  format?: string
  className?: string
}

export function DateTimeDisplay(props: DateTimeProps): ReactNode {
  const { value, format = 'MM/dd/yy, h:mm a', className } = props
  if (!value) {
    return null
  }
  let date: Date | undefined
  if (typeof value === 'string') {
    date = parseISO(value)
    if (Number.isNaN(date.getTime())) {
      date = new Date(value)
    }
  } else {
    date = value
  }
  const formattedDate = formatDate(date, format)
  const Element = props.element ?? 'div'
  return <Element className={className}>{formattedDate}</Element>
}

export function DateDisplay(props: DateTimeProps): ReactNode {
  const { format = 'M/d/yy', ...rest } = props
  return <DateTimeDisplay format={format} {...rest} />
}

export function TimeDisplay(props: DateTimeProps): ReactNode {
  const { format = 'h:mm a', ...rest } = props
  return <DateTimeDisplay format={format} {...rest} />
}
